export const fragenAutoExport = [
  {
    question: "Wie unterscheidet sich Autoeinfachlos von anderen Plattformen?",
    answer: (
      <>
        <p>
          Autoeinfachlos unterscheidet sich deutlich von klassischen
          Ankaufsplattformen und Händlern. Während viele Anbieter darauf
          abzielen, dein Auto zu einem möglichst niedrigen Preis direkt
          anzukaufen, sind wir eine Vermittlungsplattform, die für dich
          arbeitet, um den besten Preis zu erzielen. Unser Fokus liegt nicht auf
          einem günstigen Ankauf, sondern auf einer marktgerechten Vermittlung
          deines Autos – egal, ob es fahrbereit, kaputt oder defekt ist.
        </p>

        <p>
          Mit einem Netzwerk von über 5.000 geprüften Händlern ermöglichen wir
          dir, den echten Marktwert für dein kaputtes oder defektes Auto zu
          erhalten. Händler treten in Konkurrenz, um dir das beste Angebot zu
          machen. Du entscheidest, welches Angebot du annimmst – und das alles
          schnell, transparent und unkompliziert.
        </p>
        <p>
          Darüber hinaus bieten wir dir eine kostenlose Abholung deines Autos
          und eine schnelle Bezahlung, direkt auf dein Bankkonto. Mit
          Autoeinfachlos wird der Verkaufsprozess nicht nur stressfrei, sondern
          auch fair und profitabel.
        </p>
      </>
    ),
  },
  {
    question: "Was zählt als kaputtes oder defektes Auto?",
    answer: (
      <>
        <p>
          Ein kaputtes oder defektes Auto ist ein Fahrzeug, das aufgrund von
          Schäden oder technischen Mängeln nicht mehr vollständig funktionsfähig
          ist. Dazu gehören unter anderem:
        </p>

        <ul className="AV-Fragen-ul">
          <li>
            <strong>Unfallschäden: </strong>
            Fahrzeuge, die nach einem Unfall beschädigt wurden.
          </li>
          <li>
            <strong>Motorschäden: </strong>
            Probleme mit dem Motor, die Reparaturen erforderlich machen oder den
            Betrieb unmöglich machen.
          </li>
          <li>
            <strong>Getriebeschäden: </strong>
            Defekte im Getriebe, die das Fahren erschweren oder unmöglich
            machen.
          </li>
          <li>
            <strong>Zylinderkopfschäden: </strong>
            Schäden, die zu einem erheblichen Leistungsverlust führen.
          </li>
          <li>
            <strong>Karosserieschäden: </strong>
            Beeinträchtigungen der Fahrzeugstruktur, wie Dellen oder Rost.
          </li>
          <li>
            <strong>Elektronikprobleme: </strong>
            Defekte an der Elektrik oder Elektronik, die die Funktion
            beeinträchtigen.
          </li>
          <li>
            <strong>Hagel- oder Wetterschäden: </strong>
            Schäden durch Wetterereignisse, wie Hagel oder Überschwemmungen.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: "Ist es möglich, ein nicht fahrbereites Auto zu verkaufen?",
    answer: (
      <>
        <p>
          Ja! Bei Autoeinfachlos kannst du auch ein nicht fahrbereites Auto ganz
          unkompliziert verkaufen. Der große Vorteil bei uns: Du musst dein
          defektes Auto weder in eine Filiale noch sonst wohin bringen. Dank
          unserer kostenlosen Abholung wird dein Fahrzeug direkt bei dir zu
          Hause, am Arbeitsplatz oder einem anderen Ort deiner Wahl abgeholt –
          ohne dass du es bewegen oder abschleppen lassen musst. Das macht den
          Verkaufsprozess für nicht fahrbereite Autos besonders stressfrei und
          bequem.
        </p>
      </>
    ),
  },
  {
    question:
      "Muss ich Reparaturen durchführen, bevor ich mein kaputtes Auto verkaufe?",
    answer: (
      <>
        <p>
          Nein, Reparaturen sind nicht notwendig, bevor du dein kaputtes Auto
          verkaufst. Du kannst deinen defekten PKW direkt verkaufen, ohne Zeit
          und Geld in teure Instandsetzungen zu investieren. Die Kosten für
          Reparaturen werden in der Regel nicht auf den Wagenwert aufgerechnet,
          wodurch sich solche Investitionen oft nicht lohnen. Außerdem können
          bei erneuten Defekten viele reparierte Autoteile von der Reklamation
          ausgeschlossen sein.
        </p>
      </>
    ),
  },
  {
    question: "Wie wird der Wert meines defekten Autos ermittelt?",
    answer: (
      <>
        <p>
          Der Wert deines defekten Autos wird bei Autoeinfachlos marktgerecht
          ermittelt. Unsere Software bewertet den Zustand und die Details deines
          Fahrzeugs präzise, während unsere Mitarbeiter die Ergebnisse prüfen
          und verfeinern, um dir eine faire Orientierung zu bieten.
        </p>

        <p>
          Der tatsächliche Verkaufspreis entsteht jedoch in einer
          Online-Auktion, bei der über 5.000 geprüfte Händler um den besten
          Preis bieten. Dieser Wettbewerb garantiert, dass du den
          höchstmöglichen Preis für dein Fahrzeug erhältst – transparent, fair
          und marktgerecht.
        </p>
      </>
    ),
  },
  {
    question: "Ist die Abholung meines defekten Autos wirklich kostenlos?",
    answer: (
      <>
        <p>
          Ja, die Abholung deines defekten Autos ist bei Autoeinfachlos immer
          kostenlos. Egal, ob dein Fahrzeug nicht fahrbereit ist oder schwere
          Schäden aufweist – unser Service umfasst eine kostenlose Abholung
          direkt bei dir zu Hause, am Arbeitsplatz oder an einem Ort deiner
          Wahl. Du musst dich weder um die Überführung noch um zusätzliche
          Kosten kümmern.
        </p>
      </>
    ),
  },
  {
    question: "Wie lange dauert es, mein defektes Auto zu verkaufen?",
    answer: (
      <>
        <p>
          Der Verkauf deines defekten Autos kann bei Autoeinfachlos schnell und
          unkompliziert abgewickelt werden. In den meisten Fällen ist der
          gesamte Prozess – von der Bewertung bis zur Abholung – innerhalb von
          24 bis 72 Stunden abgeschlossen. Dank unserer effizienten
          Online-Auktionen und unserem großen Händlernetzwerk erhältst du
          schnell ein Angebot und kannst dein Auto stressfrei verkaufen.
        </p>
      </>
    ),
  },
  {
    question:
      "Was sind die Vorteile, wenn ich mein Auto über Autoeinfachlos verkaufe?",
    answer: (
      <>
        <p>
          Der Verkaufsprozess beim Autoexport ist schnell und einfach – in nur
          drei Schritten ist alles erledigt:
        </p>
        <ul className="AV-Fragen-ul">
          <li>
            <strong>Bestpreis Garantie: </strong> <br />
            Dank unseres Netzwerks aus über 5.000 geprüften Händlern bieten wir
            dir den bestmöglichen Preis für dein Auto – unabhängig vom Zustand.
            Händler treten in einer Online-Auktion gegeneinander an, um den
            höchstmöglichen Preis zu erzielen.
          </li>
          <li>
            <strong>Keine Überführung nötig: </strong> <br />
            Dein Auto wird kostenlos direkt bei dir zu Hause, am Arbeitsplatz
            oder an einem anderen Ort deiner Wahl abgeholt – auch wenn es nicht
            fahrbereit ist.
          </li>
          <li>
            <strong>Schneller Verkaufsprozess: </strong> <br />
            Der gesamte Verkauf wird meist innerhalb von 24 bis 48 Stunden
            abgeschlossen – von der Bewertung bis zur Abholung und Bezahlung.
          </li>
          <li>
            <strong>Stressfreie Abwicklung: </strong> <br />
            Keine lästige Suche nach Käufern, keine Verhandlungen, keine
            Unsicherheiten. Unser Service ist einfach, transparent und
            kundenfreundlich.
          </li>
          <li>
            <strong>Schnelle Bezahlung: </strong> <br />
            Das Geld wird direkt nach dem Verkauf auf dein Bankkonto überwiesen
            – schnell und sicher.
          </li>
          <li>
            <strong>Kein Risiko: </strong> <br />
            Anders als beim Privatverkauf gibt es keine Gefahr von Reklamationen
            oder rechtlichen Problemen.
          </li>
        </ul>
        <br />

        <p>
          Autoeinfachlos macht den Verkauf deines Autos einfach, fair und bequem
          – ohne versteckte Kosten oder Risiken.
        </p>
      </>
    ),
  },
  {
    question: "Fallen beim Autoexport zusätzliche Kosten an?",
    answer: (
      <>
        <p>
          Nein, unser Service ist für dich komplett kostenlos! Vom ersten
          Schritt der Bewertung bis zur Abholung und Bezahlung entstehen dir
          keinerlei Kosten. Du kannst dich zurücklehnen, während wir uns um
          alles kümmern.
        </p>
      </>
    ),
  },
  {
    question:
      "Kann ich den Verkauf jederzeit abbrechen, wenn ich es mir anders überlege?",
    answer: (
      <>
        <p>
          Ja, natürlich! Du kannst den Verkauf jederzeit abbrechen, falls du es
          dir anders überlegst. Unser Service ist völlig unverbindlich, und du
          behältst die volle Kontrolle über den Prozess.
        </p>
      </>
    ),
  },
];
